import React, { FC } from 'react';
import './about.scss';
import hands from './hands.png';

const About = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
  <div className='about'>
    <div className='bannerContainer'>
      <img className='banner' src={hands} />
      <div className='cursive'>hey!</div>
      <span className='default'>we're <span className='ricecake-title'>ricecake collective</span>.</span>
    </div>
    <div className='aboutContent page'>
      <div className='title'>About Us</div>
      <div>Ricecake Collective is a Bay Area-based art collective rooted in community, creativity, and inclusivity. We’re dedicated to uplifting local creators—especially BIPOC, queer, and underrepresented artists—by providing spaces where diverse narratives can be shared, celebrated, and supported.</div>
      <div className='spacer'></div>
      <div>Through art markets, creative cohorts, and community-driven events, we create opportunities for artists of all backgrounds to connect, grow, and thrive. Whether you're a seasoned creative or just beginning your journey, Ricecake is here to help you show up as your most authentic, creative self.</div>
      <div className='spacer'></div>
      <div>We believe that when artists are empowered, communities flourish—and we’re building that future together, one connection at a time. 💛</div>
      <div className='spacer'></div>

    </div>
  </div>
  );
}

export default About;
